import { ref, reactive, } from 'vue';
import {
  updatePassword,
} from '../request';

const submitFn = (item, button, loadFn, fn)=>{
  updatePassword({
    ...item,
    randomNumber: randomNumber,
  }).then(res=>{
    if(res.data.code == 1004){
      fn();
    }
    loadFn();
  }).catch(err=>{
    loadFn();
    console.log(err);
  });
}
const submit = (form, item, button, loadFn, fn)=>{
  // console.log(form, item, button, loadFn, fn);
  form.value.validate((valid)=>{
    // console.log(valid);
    if(valid){
      submitFn(item, button, loadFn, fn);
    }else{
      loadFn();
    }
  });
};
const close = ()=>{
  for(const key in target){
    target[key] = undefined;
  }
  showFlag.value = false;
}
const showFlagChange = (flag)=>{
  showFlag.value = flag;
}

let randomNumber = null;
const randomNumberChange = (val, fn)=>{
  randomNumber = val;
  fn(val);
}

const funItem = {
  close: close,
  copyClose: close,
  submit: submit,
  copySubmit: submit,
  showFlagChange: showFlagChange,
}
const showFlag = ref(false);
const target = reactive({});

const buttonList = ref([
  { name: '取消', fun: (...ags)=>{ funItem.close(...ags); }, type: 'danger', },
  { name: '确定', fun: (...ags)=>{ funItem.submit(...ags); }, type: 'primary', },
]);
const inputList = ref([
  { name: '旧密码', prop: 'oldPwd', type: 'input', },
  { name: '新密码', prop: 'newPwd', type: 'input', },
  { name: '验证码', prop: 'verifyCode', type: 'verifycode',
    randomNumberChange: randomNumberChange,
  },
]);
const rules = reactive({
  oldPwd: [
    { required: true, message: '请输入旧密码', trigger: 'blur' },
  ],
  newPwd: [
    { required: true, message: '请输入新密码', trigger: 'blur' },
  ],
  verifyCode: [
    { required: true, message: '请输入验证码', trigger: 'blur' },
  ],
});

export default reactive({
  showFlag: showFlag,
  target: target,
  buttonList: buttonList,
  inputList: inputList,
  rules: rules,
  funItem: funItem,
})